var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8720_321)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_radial_8720_321)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8720_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87059 10.6782C7.74118 7.14302 2 7.95884 2 7.95884C2 7.95884 2.18824 15.0292 7.55294 13.9415C7.17647 11.3128 5.76471 10.5876 5.76471 10.5876C8.4 10.5876 8.58824 13.6696 8.58824 13.6696L8.52066 19H10.4926L10.4706 14.0321C10.4706 14.0321 10.4706 10.4969 13.2941 9.59047C13.2941 9.59047 11.4118 12.3099 11.4118 14.1228C18 14.7573 18 6.05526 18 6.05526C18 6.05526 9.62353 5.1488 8.87059 10.6782Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.6667C14.7865 18.6667 18.6667 14.7865 18.6667 10C18.6667 5.21353 14.7865 1.33333 10 1.33333C5.21353 1.33333 1.33333 5.21353 1.33333 10C1.33333 14.7865 5.21353 18.6667 10 18.6667ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint1_linear_8720_321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8720_321",
    x: 2,
    y: 6,
    width: 16.4792,
    height: 13.4792,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.479185,
    dy: 0.479185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8720_321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8720_321",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8720_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10 10) rotate(90) scale(16.2222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ACC4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8720_321",
    x1: -3.22222,
    y1: -5.22222,
    x2: 17.1667,
    y2: 19.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2F739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279A3A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8720_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmingLogo);
export default __webpack_public_path__ + "static/media/farming_logo.51f24aab6d4a74fd7c106d20708852ae.svg";
export { ForwardRef as ReactComponent };